import {Events, Config, Classes} from '../models';
import {isTouch, aspectRatio, getTopLeftOfElement} from '../helpers';

import PIXI from 'pixi.js/bin/pixi.min.js';
// this is buggy:
// import Pixi from 'pixi.js';

import TwistFilter from './filters/twistFilter';
import WaveFilter from './filters/WaveFilter';

// import imgA from './filters/noise/waves.jpg';
// import DisplacementFilter from './filters/CustomDisplacementFilter';

var waves = function(obj) {
	// variables, accessible anywhere in private and public functions
	// do not need to use this.[var name]
	var el,
		renderer,
		stage,
		container,
		gui,
		waves = [],
		waveFilters = [];

	var numWaves = 7,
		colors = [
			0xFF2AA6,
			0xA150FF,
			0x63B6FF,
			0x6BFFDE,
			0xC5FF8F,
			0xFFBB89,
			0xFF7E73
		];

	function init() {
		trace(' --- init waves ---');
		// assign
		el = obj.el;

		gui = document.querySelector('.gui');

		window.PIXI = PIXI;

		renderer = PIXI.autoDetectRenderer(Config.w.w, Config.w.h, {'transparent':true} );
		
        el.appendChild(renderer.view);

        // Stage
        stage = new PIXI.Stage(0xFF0000, true);

		// Container
        container = new PIXI.Container();
        
        stage.addChild(container);

        stage.interactive = true;

        createLayers();


        _redraw();
	}

	function createLayers() {
		// var sprite = new PIXI.Sprite.fromImage(imgA);
		
		var waveFilter = new WaveFilter();

		// start from top down to bottom.
		for( var l = 0; l < numWaves; l++){
			var waveContainer = new PIXI.Container();
			var wave = new PIXI.Graphics();
			var background = new PIXI.Graphics();

			background.moveTo(0,0);
			background.lineTo(0,Config.w.h);
			background.lineTo(Config.w.w,Config.w.h);
			background.lineTo(Config.w.w,0);


			var color = colors[l];


			waveContainer.width = Config.w.w;
			waveContainer.height = Config.w.h;

			// begin a green fill..
			wave.beginFill( color );
			 
			// draw - change the height as needed.
			var y = (l/numWaves) * Config.w.h,
				h = Config.w.h * (1/numWaves);

			// start top left, clockwise
			wave.moveTo(0,y);
			// top right
			wave.lineTo(Config.w.w, y);
			// bottom right
			wave.lineTo(Config.w.w, y+h);
			// bottom left
			wave.lineTo(0, y+h);
			 
			// end the fill
			wave.endFill();
			
			// wave.alpha = 0.5;

			var waveFilter = new WaveFilter();
			// waveFilter.offset.x = 0;
			// waveFilter.offset.y = 0;
			// waveFilter.radius = 0.5;
			// waveFilter.angle = 0.5;
			
			var twistFilter = new TwistFilter();

			waveFilter.timeTicker = 10.0 * Math.random();

			waves.push(wave);
			
			waveContainer.filters = [ twistFilter ];

			waveFilters.push(twistFilter);
			
			// waveFilters.push(displacementFilter);

			// add it the stage so we see it on our screens..
			waveContainer.addChild(background);
			waveContainer.addChild(wave);
			container.addChild(waveContainer);


			trace( waveContainer.width + ' x ' + waveContainer.height );

			
		}

		// var displacementFilter = new DisplacementFilter(sprite);

		// waveFilters.push(waveFilter);

		// var waveFilter = new WaveFilter();
		// 	waveFilter.offset.x = 0;
		// 	waveFilter.offset.y = 0;
		// 	waveFilter.radius = 5.0;
		// 	waveFilter.angle = 0.5;

		// container.filters = [
		// 	// waveFilter
		// 	// displacementFilter
  		// ];

	}

	// private functions only accessible by the contents of the function, public or private
	function bindEvents(){
		// window.App.removeFromCallStack(scroll, 'scroll' );
		// window.App.removeFromCallStack(resize, 'resize' );

	}

	function remove() {

		// window.App.removeFromCallStack(scroll, 'scroll' );
		// window.App.removeFromCallStack(resize, 'resize' );

		el.remove();
	}
	
	function scroll() {

	}

	function _update() {

	}

	function resize() {

	}

	function _redraw() {
		var increment = 0.5;

		for( var w = 0; w < waveFilters.length; w++){
			var wave = waves[w];
			var waveFilter = waveFilters[w];
			// waveFilter.radius = waveFilter.radius + increment;
			// waveFilers[w].angle = waveFilers[w].angle
			
			/*
			waveFilter.offset = {x: waveFilter.offset.x + 0.1 , y: waveFilter.offset.y - 0.01 };
			
			if( waveFilter.offset.x > 1.0 ){
				// trace(' reset ');
				waveFilter.offset = {x: 1.0, y: waveFilter.offset.y };
			}
			

			if( waveFilter.direction > 0 ){
				waveFilter.angle = waveFilter.angle + 0.01;
				if( waveFilter.angle > 0.75 ){
					waveFilter.direction = -1;
				}
			}else{
				waveFilter.angle = waveFilter.angle - 0.01;
				if( waveFilter.angle < -0.5 ){
					waveFilter.direction = 1;
				}
			}
			*/

			var offsetUpdate = waveFilter.offset;
			// offsetUpdate.y += 0.001;
			// if( offsetUpdate.y > 1 ){
			// 	offsetUpdate.y = 0;
			// }

			var difX = (offsetUpdate.x - (Config.mouse.px / Config.w.w));
			var difY = (offsetUpdate.y - (Config.mouse.py / Config.w.h));

			offsetUpdate.x -= difX * 0.05;
			offsetUpdate.y -= difY * 0.05;

			waveFilter.angle = ((difX+difY)/2) * 40;

			waveFilter.radius = 1.0 + ( ((difX+difY)/2) * 1.5 );

			// waveFilter.radius += 0.001;
			// if( waveFilter.radius > 0.75){
			// 	waveFilter.radius = 0;
			// }

			// waveFilter.angle += 0.001;
			// if( waveFilter.angle > 5){
			// 	waveFilter.angle = 0;
			// }



			waveFilter.offset = offsetUpdate

			// waveFilter.scale.x += 0.0;
			// waveFilter.scale.y += 10.1;

			waveFilter.timeTicker += 0.1;
		}

		gui.innerHTML  = "offset.x :"+(Math.round( offsetUpdate.x * 100) / 100);
		gui.innerHTML += '<br/>offset.y :'+ (Math.round( offsetUpdate.y * 100) / 100);
		gui.innerHTML += "<br/>radius :"+ (Math.round( waveFilter.radius * 100) / 100);
		gui.innerHTML += "<br/>angle :"+(Math.round( waveFilter.angle * 100) / 100); 
		renderer.render(stage);
	}

	// initialize
	init();

	// public functions accessible externally.
	return {
		getEl : function() {
			return el
		},

		update : function() {
			_update();
			// resize();
		},

		destory : function() {
			remove();
		},

		redraw : function() {

			_redraw();
		}
		
	}
}

module.exports = waves;




/** WEBPACK FOOTER **
 ** ./src/js/controllers/pixiwaves.js
 **/